import { render, staticRenderFns } from "./DtEvalStudent.vue?vue&type=template&id=7c49dc15&scoped=true&"
import script from "./DtEvalStudent.vue?vue&type=script&lang=js&"
export * from "./DtEvalStudent.vue?vue&type=script&lang=js&"
import style0 from "./DtEvalStudent.vue?vue&type=style&index=0&id=7c49dc15&scoped=true&lang=scss&"
import style1 from "./DtEvalStudent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49dc15",
  null
  
)

export default component.exports